import { differenceInMonths, differenceInYears, isValid as isValidDate } from "date-fns";
import { formatDateOfBirth } from "@/lib/string";

export const getBirthDateWithAge = (birthDate: string): string => {
  if (!birthDate) {
    return "-";
  }

  const parsedBirthDate = new Date(birthDate);

  if (!isValidDate(parsedBirthDate)) {
    return "-";
  }

  const today = new Date();
  const ageYears = differenceInYears(today, parsedBirthDate);

  if (ageYears < 1) {
    const months = Math.max(differenceInMonths(today, parsedBirthDate), 0);
    const monthText = months === 1 ? "1 mês" : `${months} meses`;
    return `${formatDateOfBirth(birthDate)}  —  ${monthText}`;
  }

  if (ageYears === 1) {
    return `${formatDateOfBirth(birthDate)}  —  1 ano`;
  }

  return `${formatDateOfBirth(birthDate)}  —  ${ageYears} anos`;
};
